<script>
import { mapGetters } from 'vuex'
import moment from "moment"

import Translatable from '@src/mixins/translatable.js'

export default {
  mixins: [
    Translatable
  ],
  computed: {
    ...mapGetters('eShop', [
      'userData',
      'isFieldsValid',
      'cards',
      'subscribe',
      'selectedType',
      'pageData'
    ]),
    arrivalDayFormated() {
      const date = this.userData.arrivalDay
      return date ? moment(date).format("DD/MM/YYYY") : ''
    },
    isValidDate() {
      return moment(this.userData.arrivalDay).isBetween(this.pageData.startDate, this.pageData.endDate) ||
      moment(this.userData.arrivalDay).isSame(this.pageData.startDate) ||
      this.arrivalDayFormated === moment(this.pageData.endDate).format("DD/MM/YYYY")
    },
    paymentData() {
      const user = this.userData
      const type = this.selectedType
      const subscribe = this.subscribe

      const data = {
        pickup_date: moment(user.arrivalDay).format("YYYY-MM-DD"),
        customer_name: user.name,
        customer_email: user.email,
        checkout_delivery: type,
        subscribe,
        source: 1,
        items: [],
      }
      const op = (card, count, cardType) => {
        card[count] &&
        data.items.push({
          id: card[cardType].id,
          count: card[count]
        })
      }
      this.cards.forEach(card => {
        if (type === 'card') {
          op(card, 'adultCardCount', 'adultCard')
          op(card, 'studentCardCount', 'studentCard')
        } else {
          op(card, 'adultCardCount', 'adultCardVirtual')
          op(card, 'studentCardCount', 'studentCardVirtual')
        }
      })

      return data
    }
  },

  methods: {
    sendUserData() {
      if (this.isValidDate) {
        this.$store.dispatch('eShop/sendCred', this.paymentData)
      }
    }
  }
}
</script>

<template>
  <div class="user-form">
    <div class="input-container">
      <label for="name" class="input-title-data">{{ getTranslatedContent('ESHOP_review_order_date_field') }}
        <p>{{ arrivalDayFormated }}</p>
      </label>
    </div>
    <div class="input-container">
      <label for="name" class="input-title-data">{{ getTranslatedContent('ESHOP_review_order_name_field') }}
        <p>{{ userData.name }}</p>
      </label>
    </div>
    <div class="input-container">
      <label for="email" class="input-title-data">{{ getTranslatedContent('ESHOP_review_order_email_field') }}
        <p>{{ userData.email }}</p>
      </label>
    </div>
    <div class="button-container">
      <button
        class="button-send"
        :disabled="!isFieldsValid"
        :class="isFieldsValid ? '' : 'disabled'"
        @click="sendUserData"
      >
        {{ getTranslatedContent('ESHOP_review_order_payment_btn') }}
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
@import '@styles/form.scss';

.user-form {
  margin: 40px 0 0 30px;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin: 20px 0 0 0;
}

.button-send {
  width: 100%;
  height: 48px;
  background: $orange;
  border-radius: 5px;
  border: 1px solid $orange;
  text-transform: uppercase;
  font-family: Open, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 130%;
  color: $white;

  &:hover {
    border: 1px solid $hover-orange;
    background: $hover-orange;
  }

  &.disabled {
    background: $gray;
    border: none;
    opacity: 0.4;
  }
}

.button-cancel {
  min-width: 175px;
  height: 48px;
  border: 1px solid $gray;
  border-radius: 5px;
  background: $white;
  color: $gray;
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  padding: 12px 30px;

  &:hover {
    border: none;
    background: $gray;
    color: $white;
  }
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {
  .user-form {
    margin: 4px 0 0 0px;
    padding: 0 8px;
  }

  .button-container {
    flex-direction: column;
    margin-top: 10px;
  }

  .button-send {
    width: 100%;
  }
}
</style>
